import { host } from './../config/api';

export default class ProvisionAPI {
  /* 4.3(get) 下載保單條款 */
  static download(policyNo) {
    return host + '/provision/download?policyNo=' + policyNo;
  }
}
